/* eslint react/prop-types: 0 */
import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import {
  FormInput,
  Icon
} from 'camino-react'
import { isEmpty, map } from 'lodash'

const AttributesEqualCondition = ({
  update,
  options: {
    clients,
    employees,
    queues,
    boolean,
    ticketStatuses,
    services,
    priorities,
    regions,
    ticketTypes,
    alertSources,
    alertStatuses,
    alertAffectedServices,
    alertDeviceNames
  },
  predicates = {},
  type
}) => {
  const parsePredicatesToArray = () => (
    map(predicates, (value, key) => ({ name: key, value }))
  )

  const [attributes, setAttributes] = useState(parsePredicatesToArray)

  useEffect(() => {
    const data = {}

    attributes.forEach((attribute) => {
      data[attribute.name] = attribute.value
    })

    update(null, data)
  }, [attributes])

  const optionsForTicket = [
    {
      label: 'Client',
      value: 'client_id',
      subOptions: clients
    },
    {
      label: 'Assignee',
      value: 'assignee_user_id',
      subOptions: employees
    },
    {
      label: 'Queue',
      value: 'queue_id',
      subOptions: queues
    },
    {
      label: 'Escalation Queue',
      value: 'escalation_queue_id',
      subOptions: queues
    },
    {
      label: 'Escalation Owner',
      value: 'escalation_owner_id',
      subOptions: employees
    },
    {
      label: 'Client Contact',
      value: 'client_contact_id',
      subOptions: employees
    },
    {
      label: 'Chargeable',
      value: 'chargeable',
      subOptions: boolean
    },
    {
      label: 'Need Escalation?',
      value: 'needs_escalation',
      subOptions: boolean
    },
    {
      label: 'Client Managed',
      value: 'client_managed',
      subOptions: boolean
    },
    {
      label: 'Service Category',
      value: 'service_category_id',
      subOptions: services
    },
    {
      label: 'Sub Category',
      value: 'sub_category_id',
      subOptions: services
    },
    {
      label: 'Priority',
      value: 'priority_id',
      subOptions: priorities
    },
    {
      label: 'Status',
      value: 'status_id',
      subOptions: ticketStatuses
    },
    {
      label: 'Ticket Type',
      value: 'ticket_type_id',
      subOptions: ticketTypes
    },
    {
      label: 'Region',
      value: 'region_id',
      subOptions: regions
    }
  ]

  const alertPriorities = [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 }
  ]

  const optionsForAlert = [
    { label: 'Source', value: 'source', subOptions: alertSources },
    { label: 'Status', value: 'status', subOptions: alertStatuses },
    { label: 'Affected Service', value: 'affected_service', subOptions: alertAffectedServices },
    { label: 'Device Name', value: 'device_name', subOptions: alertDeviceNames },
    { label: 'Client', value: 'client_id', subOptions: clients },
    { label: 'Priority', value: 'priority', subOptions: alertPriorities }
  ]

  const subOptions = (value) => {
    const options = type === 'Ticket' ? optionsForTicket : optionsForAlert

    return options.find(option => option.value === value)?.subOptions || []
  }

  const addAttribute = () => {
    const attribute = { name: null, value: null }

    setAttributes(prevState => [...prevState, attribute])
  }

  const removeAttribute = (attribute) => {
    const newAttributes = attributes.filter(attr => attr !== attribute)

    setAttributes(newAttributes)
  }

  const handleValue = (attribute, value) => {
    const newAttributes = [...attributes]
    const attributeToUpdate = newAttributes.find(attr => attr === attribute)
    attributeToUpdate.value = value

    setAttributes(newAttributes)
  }

  const handleAttribute = (attribute, name) => {
    const newAttributes = [...attributes]
    const attributeToUpdate = newAttributes.find(attr => attr === attribute)
    attributeToUpdate.name = name
    attributeToUpdate.value = null

    setAttributes(newAttributes)
  }

  return (
    <>
      {attributes.map(attribute => (
        <div className="flex">
          <div className="w-1/2 mr-6">
            <FormInput label="Attribute">
              <Select
                options={type === 'Ticket' ? optionsForTicket : optionsForAlert}
                value={attribute.name}
                onChange={e => handleAttribute(attribute, e.value)}
              />
            </FormInput>
          </div>

          <div className="w-1/2 mr-6">
            <FormInput label="Value">
              <Select
                options={subOptions(attribute.name)}
                value={attribute.value}
                onChange={e => handleValue(attribute, e.value)}
                disabled={isEmpty(attribute.name)}
              />
            </FormInput>
          </div>

          <button
            className="text-3xl text-blue-500 hover:text-blue-700 cursor-pointer duration-300 ml-4"
            onClick={() => removeAttribute(attribute)}
            type="button"
          >
            <Icon type="trash" />
          </button>
        </div>
      ))}

      <button
        className="text-2xl font-semibold text-blue-500 hover:text-blue-700 cursor-pointer duration-300"
        onClick={addAttribute}
        type="button"
      >
        Add Conditions
      </button>
    </>
  )
}

export default AttributesEqualCondition
